import store from "../../../../store";
import sessionSocket from "../../../../socket/sessionSocket";
import { updateInputHeight } from "../../../../utilities/inputFormatter";
import { constructAndLogError } from "../../../../utilities/errorLogger";
import ELYXUtils from "../../../../ELYX/ELYXUtils";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

export function setChatDefaults() {
  const sessionPreferences = store.state.room.sessionPreferences;
  const chatOpen = sessionPreferences.chatOpen;
  const data = { widget: "chat", newState: chatOpen };
  store.dispatch("toolbar/setWidget", data);
}

export async function sendChatMessage() {
  const userCurrentChatText = store.state.session.userCurrentChatText;
  if (!userCurrentChatText) return;
  try {
    /* Set sending message status to true */
    store.dispatch("session/setSendingMessageStatus", true);

    /** Ensure user won't post blacklisted words */
    if (!ELYXUtils.checkBlacklistedWords(userCurrentChatText)) {
      store.dispatch("session/setSendingMessageStatus", false);
      return;
    }

    /* Prepare data for sending message */
    const UID = AuthStore.user._id;
    const SID = store.state.session.sessionID;
    if (!UID || !SID) throw new Error("userID or sessionID missing when attempting to send message");
    let messageData = {
      SID,
      UID,
      dateMS: Date.now(),
      msg: userCurrentChatText,
    };

    /* Pre-add data to visually show message as sent and clear message box */
    await store.dispatch("session/addMessage", messageData); // await exists to wait for message to clear from textbox before updating UI

    /* Update message textbox height*/
    const editor = document.getElementById("chatInputBox");
    updateInputHeight(editor);

    /* Send the message */
    const result = await sessionSocket.sendChatMessage(messageData);

    /* Set sending message status to false */
    store.dispatch("session/setSendingMessageStatus", false);

    /* Handle failed message */
    if (!result || !result.success) {
      /* Add message back to message box and remove it from the chat view */
      store.dispatch("session/removeMessage", messageData);
      updateInputHeight(editor);
      throw new Error(`Failed to send chat message for unknown reason: ${result}. The message data: ${messageData}`);
    }
  } catch (error) {
    await constructAndLogError(error);
  }
}
